export const GOOGLE_API_KEY = "AIzaSyAHLS01jiagWneMkc_W4-zQx-2MgtvWt14";



// WEBPACK FOOTER //
// ./src/App/globals.tsx